import type { CloudDishCondimentGroupSource } from '../../request/api/rbp/cloud-dish-library';

/** 调味品组引用数据拉取结果 */
interface CondimentGroupsRefFetchResult {
    /** 本次拉取是否成功 */
    ok: boolean;
    /** 接口返回数据；失败时可能仍传入旧缓存以验证隔离 */
    data: unknown;
}

/**
 * 根据引用数据拉取结果生成可供云端菜品保存使用的调味品组缓存。
 * @param result - 本次拉取状态与接口数据
 * @returns 成功且响应为数组时返回新数据，否则返回空数组
 */
export function getCondimentGroupsRawAfterRefFetch(
    result: CondimentGroupsRefFetchResult,
): CloudDishCondimentGroupSource[] {
    return result.ok && Array.isArray(result.data) ? (result.data as CloudDishCondimentGroupSource[]) : [];
}
